define('utils/objects',[],function() {

    // TODO is all this fucking code still necessary as we now support only "recent" browsers
    // Define own property
    if (!Object.prototype.hasOwnProperty) {
        Object.prototype.hasOwnProperty = function(prop) {
            var proto = this.__proto__ || this.constructor.prototype;
            return (prop in this) && (!(prop in proto) || proto[prop] !== this[prop]);
        };
    }

    // Define Object.keys
    if (!Object.keys) {
        Object.keys = function(o) {
            if (o !== Object(o)) {
                throw new TypeError('Object.keys called on non-object');
            }
            var ret = [], p;
            for (p in o) {
                if (Object.prototype.hasOwnProperty.call(o, p)) {
                    ret.push(p);
                }
            }
            return ret;
        };
    }

    return {
        /**
         * @param obj:
         *            the object to count the number of properties
         * @param ownProperty:
         *            if true, count only properties of the given object without the ones inherited from prototype
         */
        countProperties: function(obj, ownProperty) {
            var count = 0;
            for (var i in obj) {
                if (!ownProperty || obj.hasOwnProperty(i)) {
                    count++;
                }
            }
            return count;
        }
    };
});

